export const COMMON_CONSTANT = {
  TRAVEL_ENTRY:"list.TRIP_DATA.travelRequest.data.REQUEST.entryFields",
  RESULT:"result",
  COUNT:"count",
  FIELDVALUE:"fieldValue"
}
